/**
 * Copyright 2025 Phenix Real Time Solutions, Inc. Confidential and Proprietary. All Rights Reserved.
 */

const aspectRatios = [
  {
    name: '16x9 landscape',
    value: '16x9',
    index: 1
  },
  {
    name: '4x3 landscape',
    value: '4x3',
    index: 2
  }
];
const experimentalAspectRatios = [
  {
    name: '9x16 portrait',
    value: '9x16',
    index: 3
  },
  {
    name: '3x4 portrait',
    value: '3x4',
    index: 4
  }
];

export {aspectRatios, experimentalAspectRatios};